// Sorts values from least to greatest
export const sortLowToHigh = (num1, num2) => {
  return num1 - num2;
}